import { FigmaTypography, AppButton, LoadingSpinner } from "@libs/zapi-ui/custom";
import { DropdownMenuContent, DropdownMenuItem } from "@libs/zapi-ui/shadcn";
import { CheckCircleIcon, DotsThreeVerticalIcon, PencilSimpleIcon, TrashIcon } from "@phosphor-icons/react";
import { DropdownMenu, DropdownMenuTrigger } from "@radix-ui/react-dropdown-menu";
import { STUB_COMMENT_ID } from "../const/const";
import { cn } from "@/zapi-frontend/shared/lib/utils";
import { MouseEvent } from "react";

type TCommentActionsProps = {
  onDelete: (id: string) => void;
  onEdit: () => void;
  commentId: string;
  isCanEdit: boolean;
  withResolveButton?: boolean;
  isVisible: boolean;
  isSmall?: boolean;
};

export function CommentActions(props: TCommentActionsProps) {
  const { onDelete, onEdit, commentId, isCanEdit, withResolveButton, isVisible, isSmall = false } = props;

  function handleDelete(event: MouseEvent<HTMLElement>) {
    event.stopPropagation();
    onDelete(commentId);
  }

  function handleEdit(event: MouseEvent<HTMLElement>) {
    event.stopPropagation();
    onEdit();
  }

  return (
    <div
      className={cn(
        "flex items-center p-0.5 border border-innoveraZinc-150 rounded-[6px] bg-white",
        "opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity duration-300",
        (isVisible || commentId === STUB_COMMENT_ID) && "opacity-100"
      )}
    >
      {commentId === STUB_COMMENT_ID && <LoadingSpinner />}
      {commentId !== STUB_COMMENT_ID && (
        <>
          {withResolveButton && (
            <AppButton
              onClick={handleDelete}
              size="iconSm"
              appearance="text"
              data-testid={`comment-${commentId}-actions-trigger`}
            >
              <CheckCircleIcon
                className={cn("w-4 h-4 cursor-pointer transition-colors hover:text-innoveraGreen-500")}
              />
            </AppButton>
          )}
          <DropdownMenu>
            <DropdownMenuTrigger
              className={cn("w-6 h-6 flex items-center justify-center", isSmall && "!w-[18px] !h-[18px]")}
            >
              <AppButton
                size="iconSm"
                appearance="text"
                data-testid={`comment-${commentId}-actions-trigger`}
                className={cn("!rounded-[3px]", isSmall && "!w-[18px] !h-[18px]")}
              >
                <DotsThreeVerticalIcon style={{ width: "14px", height: "14px" }} />
              </AppButton>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="p-1 rounded-[8px] border border-innoveraZinc-100 bg-white">
              {isCanEdit && (
                <DropdownMenuItem
                  onClick={handleEdit}
                  variant="default"
                  className="cursor-pointer py-[5px] px-2 hover:!bg-innoveraZinc-50"
                  data-testid={`comment-${commentId}-edit`}
                >
                  <PencilSimpleIcon className="w-4 h-4 text-black" />
                  <FigmaTypography variant="label-3">Edit</FigmaTypography>
                </DropdownMenuItem>
              )}
              <DropdownMenuItem
                onClick={handleDelete}
                variant="default"
                className="cursor-pointer py-[5px] px-2 hover:!bg-innoveraZinc-50"
                data-testid={`comment-${commentId}-delete`}
              >
                <TrashIcon className="w-4 h-4 text-black" />
                <FigmaTypography variant="label-3">Delete</FigmaTypography>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </>
      )}
    </div>
  );
}
